import React from "react";

import { fade } from "../../../transition";

import * as S from "./styled";
import { Arrow } from "../../core/Pagination/styled";
import ArrowRight from "../../icon/ArrowRight";
import { Color } from "../../../settings";

interface InsightListItemProps {
  fields: {
    slug: string;
  };
  frontmatter: {
    title: string;
    date: string;
    summary: string;
  };
}

export const InsightListItem = ({
  fields,
  frontmatter,
}: InsightListItemProps) => {
  const formattedDate = new Date(frontmatter.date).toLocaleDateString("en-GB");

  return (
    <S.Wrapper>
      <S.Date>{formattedDate}</S.Date>
      <S.Title>
        <S.Link
          to={fields.slug}
          exit={{
            length: 0.25,
            trigger: ({ exit, node }) => fade({ exit, node, direction: "out" }),
          }}
          entry={{
            length: 0.25,
            trigger: ({ exit, node }) => fade({ exit, node, direction: "in" }),
            delay: 0.25,
          }}
        >
          {frontmatter.title}
          <S.ArrowWrapper>
            <Arrow>
              <ArrowRight color={Color.black} />
            </Arrow>
          </S.ArrowWrapper>
        </S.Link>
      </S.Title>
      <S.Summary>{frontmatter.summary}</S.Summary>
    </S.Wrapper>
  );
};
